//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'

export default {
	components: {
		ResponsiveImageStrapi
	},
	// data() {},
	props: ['data'],
	computed: {},
	mounted() {},
	methods: {}
}

